import { useEffect } from 'react';

const COLORS = ['#ff6ec7', '#ffe066', '#7efff5', '#a78bfa', '#ff9f43', '#ffffff'];
const SHAPES = ['✦', '✧', '⋆', '·', '★'];

function burst(x, y) {
  const count = 10;
  for (let i = 0; i < count; i++) {
    const el = document.createElement('span');
    el.textContent = SHAPES[Math.floor(Math.random() * SHAPES.length)];

    const angle = (360 / count) * i + Math.random() * 20;
    const dist = 28 + Math.random() * 32;
    const rad = (angle * Math.PI) / 180;
    const tx = Math.cos(rad) * dist;
    const ty = Math.sin(rad) * dist;
    const size = 10 + Math.random() * 10;
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const duration = 480 + Math.random() * 220;

    Object.assign(el.style, {
      position: 'fixed',
      left: `${x}px`,
      top: `${y}px`,
      fontSize: `${size}px`,
      color,
      pointerEvents: 'none',
      userSelect: 'none',
      zIndex: 99999,
      transform: 'translate(-50%, -50%)',
      animation: `sparkle-fly ${duration}ms ease-out forwards`,
      '--tx': `${tx}px`,
      '--ty': `${ty}px`,
    });

    document.body.appendChild(el);
    setTimeout(() => el.remove(), duration + 50);
  }
}

export default function TouchSparkle() {
  useEffect(() => {
    const styleId = 'touch-sparkle-style';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        @keyframes sparkle-fly {
          0%   { opacity: 1; transform: translate(-50%, -50%) scale(1); }
          100% { opacity: 0; transform: translate(calc(-50% + var(--tx)), calc(-50% + var(--ty))) scale(0.3); }
        }
      `;
      document.head.appendChild(style);
    }

    let intervalId = null;
    let currentX = 0;
    let currentY = 0;

    const onTouchStart = (e) => {
      const t = e.touches[0];
      currentX = t.clientX;
      currentY = t.clientY;
      burst(currentX, currentY);
      intervalId = setInterval(() => burst(currentX, currentY), 120);
    };

    const onTouchMove = (e) => {
      const t = e.touches[0];
      currentX = t.clientX;
      currentY = t.clientY;
    };

    const onTouchEnd = () => {
      clearInterval(intervalId);
      intervalId = null;
    };

    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onTouchEnd, { passive: true });

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('touchcancel', onTouchEnd);
    };
  }, []);

  return null;
}
